// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__I7I8Q","head":"Accordion_head__0pKmN","icon":"Accordion_icon__G0az9","content":"Accordion_content__VN63Y"};